import React from "react";
import Modal from "@mui/material/Modal";
import {
  ModalContainer,
  ModalTitle,
  ModalSubtitle,
  AppointmentList,
  AppointmentItem,
  PatientName,
  AppointmentDateTime,
  AppointmentDate,
  AppointmentTime,
  ButtonArea,
} from "./OpenAppointmentsModal.styled";
import { GenericSolidButton, RedCancelButton } from "../UI/buttons/Button.styled";
import moment from "moment";
import Colors from "../../constants/Colors";
import useResponsiveInfo from "../../hooks/useResponsiveInfo";

interface IOpenAppointmentsModal {
  visible: boolean;
  appointments: any[];
  onConfirm: () => void;
  onCancel?: () => void;
  isLogout?: boolean;
}

const OpenAppointmentsModal: React.FC<IOpenAppointmentsModal> = ({
  visible,
  appointments,
  onConfirm,
  onCancel,
  isLogout = false,
}) => {
  const { isMobile } = useResponsiveInfo();

  return (
    <Modal open={visible}>
      <ModalContainer isMobile={isMobile}>
        <ModalTitle>
          Você possui {appointments.length} atendimento(s) em andamento que ainda
          não foram finalizados.
        </ModalTitle>
        <ModalSubtitle>Revise-os para concluir os registros.</ModalSubtitle>
        <AppointmentList>
          {appointments.map((appointment, index) => (
            <AppointmentItem key={index}>
              <PatientName>{appointment.nomePaciente || appointment.paciente?.nome}</PatientName>
              <AppointmentDateTime>
                <AppointmentDate>
                  {moment.utc(appointment.dataHora || appointment.horario).format("DD [de] MMMM [de] YYYY")}
                </AppointmentDate>
                <AppointmentTime>
                  {moment.utc(appointment.dataHora || appointment.horario).format("HH:mm")}
                </AppointmentTime>
              </AppointmentDateTime>
            </AppointmentItem>
          ))}
        </AppointmentList>
        <ButtonArea>
          {isLogout ? (
            <>
              <RedCancelButton onClick={onConfirm} style={{ width: "120px" }}>
                Sair
              </RedCancelButton>
              <GenericSolidButton
                onClick={onCancel}
                color={Colors.SPM600}
                style={{ width: "120px" }}
              >
                Retornar
              </GenericSolidButton>
            </>
          ) : (
            <GenericSolidButton
              onClick={onConfirm}
              color={Colors.SPM600}
              style={{ width: "120px" }}
            >
              OK
            </GenericSolidButton>
          )}
        </ButtonArea>
      </ModalContainer>
    </Modal>
  );
};

export default OpenAppointmentsModal;
